import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, text, testId }) => (
  <div className="max-w-3xl" data-testid={testId}>
    <Reveal>
      <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">{text}</p>
      </Reveal>
    )}
  </div>
);
